<template>
  <div class="managementKnowledge container-fluid"><!-- container-fluid -->
     <div class="row">
       <div class="col-lg-2 col-md-2 col-sd-12 col-xs-12">
         <div class="syscofixed hidden-xs hidden-sm">
           <img :src="imageSrc" width="100%">
         </div>
       </div>
       <div class="col-lg-10 col-md-10 col-sd-12 col-xs-12">
         <div class="row">
            <div class="panel panel-info">
               <div class="panel-heading">{{ $t('LNG_EVALUATION_INFORMATION', this.lang) }}</div>
               <div class="panel-body">
                  <div class="col-lg-6 col-md-6 col-sd-12 col-xs-12" id="testContent">
                     <div class="text-left">
                        <h4>{{ $t('LNG_NAME', this.lang) }}: {{this.testName}}<br/>{{ $t('LNG_DISCIPLINE', this.lang) }}: {{this.testDiscipline}}<br/>{{ $t('LNG_DATE', this.lang) }}: {{this.testDate}}</h4>
                     </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-sd-12 col-xs-12" id="testContent">
                     <div class="text-left">
                        <span><pre>{{ this.testComment }}</pre></span>
                     </div>
                  </div>
               </div>
            </div>
        </div>
        
        <div class="row">
         <div class="col-lg-12 col-md-12 col-sd-12 col-xs-12">
            <table class="table table-striped table-hover">
              <thead class="">
                <tr>
                  <th>{{ $t('LNG_EXERCICES', this.lang) }}</th>
                  <th><div class="text-right">{{ $t('LNG_OBJECTIVES', this.lang) }}</div></th>
                  <th><div class="text-center">{{ $t('LNG_CATEGORY', this.lang) }}</div></th>
                </tr>
              </thead>
              <tbody>
              
                <template v-for="exercice in exercices">
                   <tr v-for="(objectif,index) in exercice.objectifs">   
                      <th scope="row">{{exercice.id}}{{objectif.part}}</th>
                      <td width="60%"><p class="text-right">{{objectif.objectif}}</p></td>
                      <td><button-group v-model="checkboxValue[objectif.exoId]">
                      <radio selected-value="declaratif" v-on:checked="chkClicked(objectif.exoId,'declaratif')">{{ $t('LNG_DECLARATIVE_KNOWLEDGE', this.lang) }}</radio>
                      <radio selected-value="procedural" v-on:checked="chkClicked(objectif.exoId,'procedural')">{{ $t('LNG_PROCESSUS_KNOWLEDGE', this.lang) }}</radio>
                      <radio selected-value="pratique" v-on:checked="chkClicked(objectif.exoId,'pratique')">{{ $t('LNG_PRACTICAL_KNOWLEDGE', this.lang) }}</radio>
                    </button-group></td>
                   </tr>
                </template>
                
              </tbody>
            </table>
           </div>
        </div>
      </div>
      <div class="row">
      <div class="col-lg-2 col-md-2 col-sd-12 col-xs-12"></div>
      <div class="col-lg-4 col-md-4 col-sd-12 col-xs-12">
         <button type="button" class="btn btn-secondary btn-lg btn-block" v-on:click.prevent="back()"><span class="glyphicon glyphicon-arrow-left"></span> {{ $t('LNG_BACK', this.lang) }}</button>
      </div>
    </div>
    </div>
    
  </div>
</template>

<script>
import { mapState } from 'vuex'
import moment from 'moment'
// const constDateFormat = 'DD.MM.YYYY'
export default {
  name: 'managementKnowledge',
  components: {
  },
  data () {
    return {
      testName: '',
      testDiscipline: '',
      testDate: '',
      testComment: '',
      exercices: [],
      checkboxValue: [],
      imageSrc: ''
    }
  },
  mounted: function () {
    moment.locale('fr-ch')
    this.loadTestData()
  },
  computed: {
    ...mapState([
      'api',
      'fullname',
      'lang'
    ]),
    adminLevel () {
      return this.$store.getters.adminLevel
    }
  },
  methods: {
    back: function () {
      this.$router.push({ path: '/test/' + this.$route.params.testId })
    },
    chkClicked (exoId, type) {
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'saveKnowledge',
          exoId: exoId,
          type: type
        },
        transformRequest: [function (data) {
          var qs = require('qs')
          return qs.stringify(data, {arrayFormat: 'brackets'})
        }]
      })
      .then((response) => {
        // Mettre à jour le graphique
        this.imageSrc = response.data.imagePath
      })
    },
    loadTestData: function () {
      this.axios({
        method: 'post',
        url: this.api,
        data: {
          method: 'getTestData',
          id: this.$route.params.testId
        },
        transformRequest: [function (data) {
          var qs = require('qs')
          return qs.stringify(data, {arrayFormat: 'brackets'})
        }]
      })
      .then((response) => {
        this.testName = response.data.name
        this.testDiscipline = response.data.discipline
        this.testComment = response.data.comment
        this.testDate = ''
        if (moment(response.data.date).isValid()) {
          this.testDate = moment(response.data.date).format('DD.MM.YYYY')
        }
        var i
        for (i = 0; i < response.data.exercices.length; i++) {
          if (this.exercices.length < response.data.exercices[i].exo) {
            this.exercices.push({id: response.data.exercices[i].exo, objectifs: []})
          }
          this.exercices[response.data.exercices[i].exo - 1].objectifs.push({objectif: response.data.exercices[i].obj, exoId: response.data.exercices[i].exoId, part: response.data.exercices[i].part})
          this.checkboxValue[response.data.exercices[i].exoId] = response.data.exercices[i].category
        }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>

<style>
</style>



// WEBPACK FOOTER //
// managementKnowledge.vue?74a870b8